import React, { useContext, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Link, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import { useStyles } from './Onboarding.styles';
import { useApiValidationSnackbar } from '../../../../../Api/useValidationSnackbar';

export const OnboardingSessionBanner = () => {
  const { onboardingCustomerId, customerName, openOnboarding } = useContext(UserContext);
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const classes = useStyles();
  const { notifyUnhandledException } = useApiValidationSnackbar();
  if (!onboardingCustomerId) return null;
  const exit = async () => {
    if (busy) return;
    setBusy(true);
    try { await openOnboarding(); navigate('/law-portal/dashboard'); }
    catch { notifyUnhandledException(); }
    finally { setBusy(false); }
  };
  return <Alert icon={false} severity="info" className={classes.banner}>
    <Box className={classes.bannerContent}>
      <Typography>{t({ id: 'onboarding.configuring' }, { customer: customerName || '' })}</Typography>
      <Box>
        <Button component={Link} to={`/law-portal/dashboard?setupCustomerId=${onboardingCustomerId}`} color="inherit" disabled={busy}>{t({ id: 'onboarding.return-setup' })}</Button>
        <Button onClick={exit} color="inherit" disabled={busy}>{t({ id: 'onboarding.exit' })}</Button>
      </Box>
    </Box>
  </Alert>;
};
